import { useManagerCouponPrint } from '@/core/domain/coupon/managerCoupon/managerCoupon.hooks';
import { Button } from 'antd';
import { useInvoiceCFEFormContext } from '../../InvoiceCFEFormProvider';
import { TaxCouponStatus } from '@/core/domain/coupon/coupons/coupons.types';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const InvoiceCFEPrint: React.FC = () => {
  const managerCouponPrint = useManagerCouponPrint();

  const { taxCoupon } = useInvoiceCFEFormContext();

  return (
    <>
      <Button
        type="primary"
        ghost
        loading={managerCouponPrint.isLoading}
        disabled={
          !taxCoupon?.sefazReferenceCode ||
          taxCoupon?.status !== TaxCouponStatus.EMITTED ||
          !hasPermissions([Authorities.FISCAL_COUPON_PRINT])
        }
        onClick={async () => {
          if (taxCoupon && taxCoupon?.sefazReferenceCode) {
            await managerCouponPrint.mutateAsync({
              sefazReferenceCode: taxCoupon.sefazReferenceCode,
            });
          }
        }}
      >
        Imprimir CF-e
      </Button>
    </>
  );
};

export default InvoiceCFEPrint;
